
    <div class="full-width" fxLayout="row" fxLayoutAlign="space-between">
      <mat-list>
        <div class="comment">
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            class="full-width mat-body-1"
            matLine
          >
            <span
              ><strong
                >{{ comment.user.firstName }}&nbsp;{{
                  comment.user.lastName
                }}</strong
              ></span
            >
          </div>
          <div
            matLine
            fxLayout="row"
            fxLayoutAlign="start center"
            class="mat-caption"
          >
            <span>{{ comment.created | date: 'short' }}</span>
          </div>
          <div class="comment-text mat-body-2" matLine>
            {{ comment?.text }}
          </div>
        </div>
      </mat-list>
      <button
        mat-icon-button
        *ngIf="
          currentUser?.id === comment.user.id ||
          currentUser?.role === roles.ADMIN
        "
        (click)="onDelete()"
      >
        <mat-icon svgIcon="delete"></mat-icon>
      </button>
    </div>
    <ng-content></ng-content>
  